import React from 'react';
import ReactDOM from 'react-dom/client';
import Invenio from './invenio.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Invenio />);